import { useCallback, useRef } from "react";
import logger from "@/utils/loggerUtil";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { actions, selectors } from "@/redux/authentication";
import { getCurrentUserAPI } from "@/apis/users";
import { initialAuthenticationState } from "@/redux/authentication/data";
import { useUser } from "@clerk/nextjs";
import { uploadResumeAPI } from "@/apis/resume";

const useFetchUserDetails = () => {
  const dispatch = useAppDispatch();
  const { user, isLoaded } = useUser();
  const fetchingRef = useRef(false);
  const signUpDetails = useAppSelector(selectors.signUpDetails);

  const fetchUserDetails = useCallback(async () => {
    if (!isLoaded || fetchingRef.current || !user) return;

    // Fetch the latest state of signUpDetails inside the callback

    const userEmail = user.emailAddresses?.[0]?.emailAddress;
    if (!userEmail) return;

    try {
      fetchingRef.current = true;

      const payload = {
        ...signUpDetails,
        email: signUpDetails.email || userEmail,
      };

      const userResponse = await getCurrentUserAPI(payload);

      if (userResponse?.success) {
        if (signUpDetails?.resumeFile) {
          await uploadResumeAPI(signUpDetails?.resumeFile);
        }

        dispatch(actions.callSetUserDetails(userResponse.data || {}));

        // Only reset signUpDetails if necessary to avoid triggering Redux updates
        if (
          JSON.stringify(signUpDetails) !==
          JSON.stringify(initialAuthenticationState.signUpDetails)
        ) {
          dispatch(
            actions.callSetSignUpDetails(
              initialAuthenticationState.signUpDetails
            )
          );
        }
      }
    } catch (error) {
      logger(error);
    } finally {
      fetchingRef.current = false;
    }
  }, [dispatch, user, isLoaded]);

  return { fetchUserDetails };
};

export default useFetchUserDetails;
